import { trackClientEvent } from 'analytics/analytics'

const CATEGORY = 'loyalty_credit_card'

/**
 * The onsite surfaces that merchandise the Société Credit Card.
 *
 * These are the values card applications get attributed to, so reporting is built on them — rename
 * one and its history stops matching. Snake case matches the other client event subjects.
 */
export const LOYALTY_CREDIT_CARD_PLACEMENTS = {
  homepageBanner: 'homepage_banner',
  societeLandingPageBanner: 'societe_landing_page_banner',
  hamburgerMenuItem: 'hamburger_menu_item',
  /** LOYAL-2739, blocked on MoneyMe — named now so the taxonomy is settled up front. */
  bookingDetailsModule: 'booking_details_module',
} as const

export type LoyaltyCreditCardPlacement =
  typeof LOYALTY_CREDIT_CARD_PLACEMENTS[keyof typeof LOYALTY_CREDIT_CARD_PLACEMENTS]

/**
 * Client events rather than the centralised `promotionView`/`promotionClick` pair: those belong to
 * growth's merchandising reporting, and emitting from here would dilute it.
 *
 * Nothing is passed as context deliberately. Every event already carries loyalty tier, LuxPlus+
 * state, page and region through `asyncBaseContext`, so attribution can segment on all of that
 * without this feature contributing its own entity.
 */

/**
 * Fired once when a placement scrolls into view.
 *
 * `nonInteraction` because the customer has not done anything — impressions would otherwise inflate
 * every engagement metric these events feed.
 */
export function trackLoyaltyCreditCardImpression(placement: LoyaltyCreditCardPlacement): void {
  trackClientEvent({
    category: CATEGORY,
    subject: placement,
    action: 'impression',
    type: 'nonInteraction',
  })
}

/** Fired when the customer activates a placement and heads for the card landing page. */
export function trackLoyaltyCreditCardClick(placement: LoyaltyCreditCardPlacement): void {
  trackClientEvent({
    category: CATEGORY,
    subject: placement,
    action: 'clicked',
    type: 'interaction',
  })
}
